type ClerkUserLike = {
    id: string;
    primaryEmailAddress?: { emailAddress?: string | null } | null;
    emailAddresses?: Array<{ emailAddress?: string | null }>;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    imageUrl?: string | null;
    username?: string | null;
};

export type ClerkProfilePayload = {
    clerk_user_id: string;
    email: string | null;
    full_name: string;
    avatar_url: string | null;
    username: string | null;
};

export function buildClerkProfilePayload(user: ClerkUserLike): ClerkProfilePayload {
    const email =
        user.primaryEmailAddress?.emailAddress ??
        user.emailAddresses?.[0]?.emailAddress ??
        null;

    const fullName =
        user.fullName ??
        (([user.firstName, user.lastName].filter(Boolean) as string[]).join(' ').trim() ||
            email ||
            'User');

    const avatarUrl = user.imageUrl && user.imageUrl.trim() ? user.imageUrl : null;
    const username = user.username && user.username.trim() ? user.username : null;

    return {
        clerk_user_id: user.id,
        email,
        full_name: fullName,
        avatar_url: avatarUrl,
        username: username,
    };
}
